import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "../data/content";
import { useBooking } from "../context/BookingContext";
import emblem from "../assets/emblem.png";

export const Footer = () => {
  const { openBooking } = useBooking();
  return (
    <footer data-testid="footer" className="bg-sora-slate text-sora-warm/90 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src={emblem} alt="Sora Speech Co. logo" className="h-11 w-11 object-contain" />
            <span className="font-display text-xl text-sora-warm">Sora Speech Co.</span>
          </div>
          <p className="text-sm leading-relaxed text-sora-warm/70">
            {CONTACT.tagline}
          </p>
        </div>

        <div>
          <h4 className="text-sora-warm font-bold text-sm uppercase tracking-[0.18em] mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {["About", "Services", "NDIS", "Reviews", "FAQ", "Contact"].map((l) => (
              <li key={l}>
                <Link data-testid={`footer-link-${l.toLowerCase()}`} to={`/${l === "About" ? "about" : l.toLowerCase()}`} className="text-sora-warm/70 hover:text-sora-sage transition-colors">
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sora-warm font-bold text-sm uppercase tracking-[0.18em] mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-2.5 text-sora-warm/70 hover:text-sora-sage transition-colors"><Mail size={16} strokeWidth={1.5} /> {CONTACT.email}</a></li>
            <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="flex items-center gap-2.5 text-sora-warm/70 hover:text-sora-sage transition-colors"><Phone size={16} strokeWidth={1.5} /> {CONTACT.phone}</a></li>
            <li className="flex items-start gap-2.5 text-sora-warm/70"><MapPin size={16} strokeWidth={1.5} className="mt-0.5" /> Mobile — most of metro Melbourne</li>
          </ul>
        </div>

        <div>
          <h4 className="text-sora-warm font-bold text-sm uppercase tracking-[0.18em] mb-4">Ready to begin?</h4>
          <p className="text-sm text-sora-warm/70 mb-4">Book an initial assessment and take the first step.</p>
          <button data-testid="footer-book-now" onClick={() => openBooking("booking")} className="bg-sora-blue text-white rounded-[18px] px-6 py-3 text-sm font-bold hover:bg-sora-sage hover:text-sora-slate transition-colors">
            Book an Appointment
          </button>
        </div>
      </div>

      <div className="border-t border-sora-warm/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-sora-warm/55">
          <p>© {new Date().getFullYear()} Sora Speech Co. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-sora-sage transition-colors">Privacy Policy</a>
            <Link to="/ndis" className="hover:text-sora-sage transition-colors">NDIS</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
